import React, { useState } from "react";
import { goToPlacedOrder } from "./goToPlacedOrder";
import { useTheme } from "../../../../hooks/ThemeContext";
import { PaymentRequestButtonElement, useElements, useStripe } from "@stripe/react-stripe-js";
import CardDetails from "./CardDetails";
import { toast } from "react-toastify";
import StripeService from "../../../../service/StripeService";
import TimeService from "../../../../service/TimeService";
import ToastService from "../../../../service/ToastService";
import { useRestaurant } from "../../../../hooks/RestaurantContext";

type Props = {
    order: any,
    setCart: any,
    amount: number,
    tipAmount: number,
    tableNumber: number | null;
    formData: any,
    onBack: any,
    onSuccessReturn: any,
    agreeToMarketing: boolean,
    marketingRefused?: boolean,
    paymentRequest: any,
    stripe: any,
    canMakePayment: boolean,
    skipMethodsScreen: boolean,
    updateQuantity: any,
    removeOption: any,
    productData: any[],
    menuSettings: any,
    openingHours: any,
    orderType: string,
    deliveryAddress: any,
    deliveryQuote: any,
    testMode: boolean
}


const PaymentDetails = (props: Props) => {

    const { theme } = useTheme();
    const { restaurantId } = useRestaurant();
    const [loading, setLoading] = useState(false);
    const [payByCardScreen, setPayByCardScreen] = useState(false);
    const elements = useElements();

    const hitBack = (e: any) => {
      e.preventDefault();
      props.onBack();
    }


    React.useEffect(() => {

      const checkMenuItems = async () => {
        let allowedMenus = await TimeService.getAllowedMenus(props.menuSettings);
        let updatedCart = false;
  
        for (let orderItem of props.order) {
          let itemObj = props.productData.filter((x) => x.productId === orderItem.id)[0];
          let menuFound = false;
          for (let menuItem of orderItem.menus) {
              if (allowedMenus.includes(menuItem)) {
                  menuFound = true;
              }
          }
          if (menuFound == false || itemObj.isDeleted || itemObj.isDisabled || itemObj.outOfStock) {
              updatedCart = true;
              props.updateQuantity(orderItem, 0);
              return false;
          }
          if (orderItem.additionalOptionIds && orderItem.additionalOptionIds.length > 0) {
              for (let addOption of orderItem.additionalOptionIds) {
                  let additionalOptionObj = props.productData.filter((x) => x.productId === addOption)[0];
                  if (!additionalOptionObj.outOfStock && !additionalOptionObj.isDisabled && !additionalOptionObj.isDeleted) {

                      let addOptionsCategoryObj = props.menuSettings.filter((x: any) => x.menuName === additionalOptionObj.menus[0])[0].categories.filter((c: any) => c.id === additionalOptionObj.category)[0];
                      if (addOptionsCategoryObj.enabled !== false && !addOptionsCategoryObj.deleted){
                          ;
                      }
                      else {
                          props.removeOption(orderItem, addOption);
                          updatedCart = true;
                          return false;
                      }

                  }
                  else {
                      props.removeOption(orderItem, addOption)
                      updatedCart = true;
                      return false;
                  }
              }
          }

        }
        return true;
      }

      if (props.paymentRequest) {
          console.log("pr")
              props.paymentRequest.on('paymentmethod', async (ev: any) => {
                checkMenuItems().then(async (response) => {
                  if (response) {

                    console.log("processing express transaction...")
                    setLoading(true);
                    const result = await StripeService.expressCheckout(
                      props.stripe,
                      ev.paymentMethod.id,
                      props.order,
                      props.amount,
                      props.tipAmount,
                      props.tableNumber,
                      props.formData,
                      props.orderType,
                      props.deliveryAddress,
                      props.deliveryQuote,
                      props.testMode,
                      restaurantId,
                      props.agreeToMarketing,
                      props.marketingRefused === true
                    );
                    setLoading(false);
                
                    if (result.status === "SUCCESS") {
                      ev.complete('success')
                      localStorage.setItem(`order_${result.orderCode}`, JSON.stringify(props.order))
                      props.setCart([]);
                      props.onSuccessReturn();
                      ToastService.showToast("Payment Successful!", {
                        style: {
                            backgroundColor: "darkgreen", // Set the toast background color to green
                            color: "white", // White text for contrast
                        },
                      });
                      goToPlacedOrder(result.orderCode, props.orderType, props.deliveryQuote, restaurantId, { orderId: (result as any).orderId ?? null, total: Number(props.amount) || null, itemCount: Array.isArray(props.order) ? props.order.reduce((n: number, it: any) => n + (Number(it?.quantity) || 1), 0) : null });
                    } else if (result.status === "QUOTE_EXPIRED") {
                        ev.complete('fail')
                        ToastService.showToast("Delivery pricing has been updated. Please try again.", {
                            style: {
                                backgroundColor: "red",
                                color: "white",
                                minHeight: "80px",
                                borderRadius: "15px",
                            },
                            autoclose: 5000
                        });
                        props.onSuccessReturn(); // Go back to cart
                    } else {
                        ev.complete('fail')
                      // PPB rejections carry a specific reason (loyalty points,
                      // reward validity, minimum spend…) — show it.
                      ToastService.showToast((result as any)?.message || "Payment Failed!", {
                        style: {
                            backgroundColor: "darkred",
                            color: "white",
                            minHeight: "80px",
                            borderRadius: "15px",
                        },
                        autoclose: 7000,
                      });
                      setLoading(false);
                    }
                  }
                  else {
                    ev.complete('fail')
                    ToastService.showToast(`Unavailable items have been removed from your cart. Please verify your cart before ordering!`, {
                      style: {
                          backgroundColor: "darkred", 
                          color: "white",
                          minHeight: "80px",
                          borderRadius: "15px",
                      },
                    });
                    props.onSuccessReturn();
                    return;
                  }

                })
      
      
              })

      }


      


    }, [props.paymentRequest, props.stripe])

    


    const getPaymentMethodButtons = () => {
      
        return (
          <>
          <div
          style={{
            display: "flex",
            color: theme.cartTextColor,
            flexGrow: "1",
            flexDirection: "column",
            padding: "20px",
            boxSizing: "border-box",
            overflowY: "scroll"
          }}
        >
          <button
            style={{
              width: "auto",
              padding: "8px 16px",
              cursor: "pointer",
              backgroundColor: theme.cartButtonColor,
              color: theme.cartButtonTextColor,
              border: "none",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "500",
              alignSelf: "flex-start",
              transition: "transform 0.2s ease",
            }}
            onClick={hitBack}
          >
            Back
          </button>
            <h2 style={{fontSize: "24px", fontWeight: 800, letterSpacing: "-0.4px", margin: "18px 0 2px"}}>How would you like to pay?</h2>
            <p style={{fontSize: "13.5px", lineHeight: 1.5, opacity: .62, margin: "0 0 14px"}}>Payments are processed securely by Stripe.</p>

              <button
                  style={{
                    height: "52px",
                    width: "100%",
                    cursor: "pointer",
                    backgroundColor: theme.payButtonColor,
                    color: theme.payButtonTextColor,
                    border: "none",
                    borderRadius: "14px",
                    fontSize: "15px",
                    fontWeight: 700,
                    fontFamily: "inherit",
                  }}
                  onClick={()=>{setPayByCardScreen(true)}}
                >
                  Credit / Debit Card
                </button>



              {
                props.paymentRequest && props.canMakePayment &&
                <div style={{marginTop: "12px"}}>
                  <PaymentRequestButtonElement
                    options={{
                      paymentRequest: props.paymentRequest,
                      style: {
                        paymentRequestButton: {
                          theme: 'dark', // Choose your theme
                          height: '52px',
                        },
                      },
                    }}
                  />
                </div>
              }
              </div>
          </>
        )
      }



    if (!payByCardScreen && !props.skipMethodsScreen){
      console.log("SKIP METHOD SCREEN FALSE: ", props.skipMethodsScreen);
        return (
            <>
                { getPaymentMethodButtons() }
            </>
        )
    }
    else {
        return (
          <div
            style={{
              display: "flex",
              color: theme.cartTextColor,
              flexGrow: "1",
              flexDirection: "column",
              padding: "20px",
              boxSizing: "border-box",
              overflowY: "scroll"
            }}
          >

  
            <CardDetails stripe={props.stripe} elements={elements} order={props.order} setCart={props.setCart} amount={props.amount} tipAmount={props.tipAmount} tableNumber={props.tableNumber} formData={props.formData} onBack={()=>{!props.skipMethodsScreen ? setPayByCardScreen(false) : props.onBack()}} onSuccessReturn={()=>props.onSuccessReturn()} updateQuantity={props.updateQuantity} removeOption={props.removeOption} productData={props.productData} menuSettings={props.menuSettings} openingHours={props.openingHours} orderType={props.orderType} deliveryAddress={props.deliveryAddress} deliveryQuote={props.deliveryQuote} agreeToMarketing={props.agreeToMarketing} marketingRefused={props.marketingRefused} testMode={props.testMode}/>
  
            </div>
        )
      }
}

export default PaymentDetails;